import { render, staticRenderFns } from "./MarketingEditAdvertCommunicationTab.vue?vue&type=template&id=65a267ea&scoped=true"
import script from "./MarketingEditAdvertCommunicationTab.vue?vue&type=script&lang=js"
export * from "./MarketingEditAdvertCommunicationTab.vue?vue&type=script&lang=js"
import style0 from "./MarketingEditAdvertCommunicationTab.vue?vue&type=style&index=0&id=65a267ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a267ea",
  null
  
)

export default component.exports